"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseModule = void 0;
const dispense_view_1 = require("./modules/dispense-view");
const router_1 = require("client/components/router");
class DispenseModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("dispense", /^\/dispense?$/, dispense_view_1.DispenseView);
    }
}
exports.DispenseModule = DispenseModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dispense/dispense.tsx
// module id = 3378
// module chunks = 0